/*
 * @Author: Json Chen
 * @Date: 2021-06-24 14:03:45
 * @LastEditTime: 2021-06-24 14:12:12
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Components/InputMaxLength.tsx
 */
import React from 'react';
import { Form } from 'antd';
import styles from './style.module.less';

const InputMaxLength = ({
  fieldName,
  maxLength,
}: {
  fieldName: string;
  maxLength: number | string;
}) => {
  return (
    <Form.Item noStyle shouldUpdate={(p, c) => p[fieldName] !== c[fieldName]}>
      {({ getFieldValue }) => {
        const value = getFieldValue(fieldName) || '';
        return (
          <span className={styles.inputMaxLength}>
            {value.length}/{maxLength}
          </span>
        );
      }}
    </Form.Item>
  );
};

export default InputMaxLength;
